
<div class="container-fluid my-5">
    <!-- Table -->
    <div class="row">
        <div class="col">
            <div class="card shadow">
                <!-- call custom table -->
                <app-custom-table [custom_page]="custom_page" [columns]="columns" [show_add_button]="show_add_button" [show_edit_button]="show_edit_button"
                    [show_delete_button]="show_delete_button" [multi_actions]="multi_actions" 
                    [visible_actions]="visible_actions" [invisible_actions]="invisible_actions" [custom_buttons]="custom_buttons"></app-custom-table>
            </div>
        </div>
    </div>

</div>